const checkPassword = (password: string, re_password: string): boolean => {
  return password === re_password && password !== '';
};

const validateEmail = (email: string): boolean => {
  /* eslint-disable */
  const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return emailRegex.test(email);
  /* eslint-enable */
};

const setStorage = (data: string, value: string) => {
  localStorage.setItem(data, value);
};

const getStorage = (data: string) => {
  return localStorage.getItem(data);
};

const removeStorage = (data: string) => {
  localStorage.removeItem(data);
};

const clearStorage = () => {
  localStorage.clear();
};

const isAuthenticated = () => {
  const userToken = getStorage('token');
  if (userToken) {
    return true;
  }
  removeStorage('token');
  return false;
};

export { checkPassword, validateEmail, setStorage, getStorage, isAuthenticated, removeStorage, clearStorage };
